package com.tovtalk.ui.navigation

/**
 * Navigation Routes - shared across Android, iOS, Web
 */
object Routes {
    const val SPLASH = "splash"
    const val OFFLINE_LAUNCH = "offline_launch"
    const val ONBOARDING = "onboarding"
    const val HOME = "home?tab={tab}&playUserId={playUserId}&playPostId={playPostId}&startPostRef={startPostRef}"
    const val PROFILE = "profile/{userId}/{fromPostId}"
    const val PROFILE_BY_USERNAME = "profile/by/{username}"
    const val PROFILE_FOLLOWERS = "profile/{userId}/followers"
    const val PROFILE_FOLLOWING = "profile/{userId}/following"
    const val PROFILE_FEED = "profile_feed/{userId}/{startPostId}"
    const val EDIT_PROFILE = "edit_profile"
    const val SETTINGS = "settings"
    const val NOTIFICATION_SETTINGS = "notification_settings"
    const val SESSIONS = "sessions"
    const val PHONE_VERIFICATION = "phone_verification"
    const val ABOUT = "about"
    const val PRIVACY = "privacy"
    const val TERMS = "terms"
    const val ACCOUNT_DELETION = "account_deletion"
    const val SAFETY = "safety"
    const val BLOCKED_USERS = "blocked_users"
    const val MY_FOLLOWING = "my_following"
    const val CONTENT_UPLOAD_MANAGEMENT = "content_upload_management"
    const val POST_DETAIL = "post/{postRef}"
    const val CHAT_DETAIL = "chat/{receiverId}/{receiverName}"
    const val CHAT_REQUESTS = "chat_requests"
    const val PRIVATE_CHATS = "private_chats"
    const val MESSAGES = "messages"
    const val SEARCH = "search"
    const val HASHTAG = "hashtag/{tag}"
    const val STATIC_PAGE = "static_page/{slug}"
    fun staticPage(slug: String) = "static_page/$slug"
    const val STORIES = "stories/{userId}"
    fun stories(userId: Int) = "stories/$userId"
}
